import * as sagaEffects from 'redux-saga/effects';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import * as loglevel from 'config/loglevel';

import types from './actionTypes';
import { addFile, setFile } from './actions';
import { status } from './constants';
import { uploadImage, createId, imageToFile } from './utils';

const { takeEvery, put } = sagaEffects;

function* handler({ payload, meta }) {
    const intl = yield getIntl();

    const { file } = payload;
    const { filesPool } = meta;

    const id = createId();

    yield put(
        addFile(filesPool, {
            uid: id,
            status: status.UPLOADING,
        }),
    );

    try {
        yield uploadImage(id, file);

        yield put(setFile(filesPool, imageToFile({ id })));
    } catch (e) {
        yield put(
            setFile(filesPool, {
                uid: id,
                status: status.ERROR,
            }),
        );
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.uploader.upload' }));
    }
}

export default function* () {
    yield takeEvery(types.UPLOAD_REQUEST, handler);
}
